import React from "react";
import { Box, HBox, VBox } from "../box/Box";
import { Skeleton } from "../skeleton/Skeleton";
import Spacer from "../spacer/Spacer";
import { Typo } from "../text/Typo";

interface InformerProps {
	title?: any;
	disabled?: boolean;
	content: any;
	busy?: boolean;
	subcontent?: any;
	color?: string;
	icon?: any;
	contentFullHeight?: boolean;
	fullHeight?: boolean;
	disableSpacer?: boolean;
	spacerHeight?: string;
}

export const Informer = ({ title, content, busy, subcontent, icon, contentFullHeight, spacerHeight, disabled, disableSpacer }: InformerProps) => {
	if (typeof content !== "string" && typeof content !== "number" && typeof content !== "boolean" && !React.isValidElement(content))
		try {
			content = JSON.stringify(content, null, 2);
		} catch (e) {
			content = content + "";
		}

	return (
		<VBox
			sx={{
				backgroundColor: "panelBackgroundPrimary",
				padding: "20px",
				borderRadius: "6px",
				cursor: disabled ? "auto" : "pointer",
				minHeight: "150px",
				boxShadow: "0px 2px 1px rgba(0,0,0,0.1)",
				gap: "10px",
				height: contentFullHeight ? "100%" : "auto",
			}}>
			{(title || icon) && (
				<HBox>
					<Typo sx={{ color: "#524b7f" }} variant="headMedium" block>
						{title}
					</Typo>
					<Spacer grow />
					<Box>{icon}</Box>
				</HBox>
			)}
			{(title || icon) && !disableSpacer && (
				<Spacer grow={contentFullHeight ? true : undefined} size={contentFullHeight ? (spacerHeight ? spacerHeight : "0px") : undefined} />
			)}

			<Skeleton busy={busy}>{typeof content === "string" || typeof content === "number" ? <Typo variant="head">{content} 1</Typo> : content}</Skeleton>
			{typeof subcontent === "string" || typeof subcontent === "number" ? <Typo variant="text">{subcontent}</Typo> : subcontent}
		</VBox>
	);
};
